import NavItem from '@ss/mtd-vue/es/components/navbar-item';
var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "mtd-navbar", class: "mtd-navbar-" + _vm.theme }, [_vm.logo || _vm.$slots.logo ? _c('a', _vm._b({ staticClass: "mtd-navbar-brand" }, 'a', _vm.logoProps, false), [_vm._t("logo", [_c('img', { attrs: { "src": _vm.logo } })])], 2) : _vm._e(), _vm.avatar ? _c('nav-item', { staticClass: "mtd-navbar-user", attrs: { "align": "right", "visible": _vm.userVisible }, on: { "update:visible": _vm.handleUserVisibleChange } }, [_c('img', { staticClass: "mtd-navbar-avatar", attrs: { "src": _vm.avatar } }), _c('span', { staticClass: "mtd-navbar-username" }, [_vm._v(_vm._s(_vm.username))]), _c('i', { directives: [{ name: "show", rawName: "v-show", value: _vm.$slots.userDropdown, expression: "$slots.userDropdown" }], staticClass: "mtdicon mtdicon-triangle mtd-navbar-user-arrow" }), _vm.$slots.userDropdown ? _c('div', { attrs: { "slot": "dropdown" }, slot: "dropdown" }, [_vm._t("userDropdown")], 2) : _vm._e()]) : _vm._e(), _vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  name: 'MtdNavbar',
  components: {
    NavItem: NavItem
  },
  props: {
    theme: {
      type: String,
      default: 'dark'
    },
    logo: String,
    logoProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    avatar: String,
    username: String,
    userVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleUserVisibleChange: function handleUserVisibleChange(v) {
      this.$emit('update:userVisible', v);
    }
  }
};